import React, { ChangeEvent, useRef, useState } from 'react';

import useTheme from '../../../../hooks/use-theme/useTheme';

import { getClassNames, noOp } from '../../../../utils/util';

import { ReactComponent as EyeClosedIcon } from '../../../../resources/icons/eye-closed.svg';
import { ReactComponent as EyeOpenIcon } from '../../../../resources/icons/eye-open.svg';
import { ReactComponent as LockIcon } from '../../../../resources/icons/lock.svg';

import './password-input.scss';

type Props = {
  id?: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  placeholder?: string;
  profile?: boolean;
};

const PasswordInput = ({ id, value, onChange, onFocus = noOp, onBlur = noOp, placeholder, profile = false }: Props) => {
  const [showPassword, setShowPassword] = useState(false);

  const { pps } = useTheme();

  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleEyeClick = () => {
    setShowPassword(!showPassword);

    if (!inputRef.current) return;

    inputRef.current.focus();
  };

  return (
    <div className={getClassNames('password-input', { pps, profile })}>
      {!profile && <LockIcon className={getClassNames('password-input__lock-icon', { pps })} />}
      <input
        id={id}
        className={getClassNames('password-input__input', { pps, profile })}
        ref={inputRef}
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <span onClick={handleEyeClick} data-testid="eye-icon">
        {showPassword ? (
          <EyeClosedIcon className={getClassNames('password-input__eye-icon', { closed: true, pps, profile })} />
        ) : (
          <EyeOpenIcon className={getClassNames('password-input__eye-icon', { pps, profile })} />
        )}
      </span>
    </div>
  );
};

export default PasswordInput;
